import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnScrollToChild } from '@wix/da-shared-react/pkg/utils/hooks/useOnScrollToChild';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import FolderContent from '../FolderContent';
import { getStickyContentHeight } from '../../helpers';
import { getGallectionsStickyBarHeight } from '../helpers';

import s from './FolderContentList.scss';

export interface Props {
  folderIds: number[];
  className?: string;
  onScrollToFolder: (folderId: number) => void;
}

const FolderContentList: React.FC<Props> = ({
  folderIds,
  onScrollToFolder,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const scrollOffsetTop =
    getStickyContentHeight(isMobile) + getGallectionsStickyBarHeight(isMobile);
  const { setChildRef } = useOnScrollToChild(
    folderIds,
    onScrollToFolder,
    scrollOffsetTop
  );

  return (
    <>
      {folderIds.map((folderId, index) => (
        <div
          id={folderId.toString()}
          key={folderId}
          className={s['folder-content-wrapper']}
          ref={node => setChildRef(folderId, node)}
        >
          <FolderContent key={folderId} folderId={folderId} />
          {index < folderIds.length - 1 && (
            <div className={s['folder-content-separator']}>
              {t('pages.gallections.youMightLikeThis')}
            </div>
          )}
        </div>
      ))}
    </>
  );
};
FolderContentList.displayName = 'FolderContentList';

export default FolderContentList;
